import { IconCar16, IconWalk16, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { ETransportType } from 'shared/types/newbuildingOffersCarousel';

interface IFromUndergroundProps {
  transportType: ETransportType;
  timeTo: string;
}

export function FromUndergroundTime({ transportType, timeTo }: IFromUndergroundProps) {
  const Icon = transportType === ETransportType.Walk ? IconWalk16 : IconCar16;

  return (
    <div className={styles['distance']} data-testid="from_underground_time">
      <div className={styles['icon']}>
        <Icon data-testid={`from_underground_time_icon_${transportType}`} color="icon-secondary-default" />
      </div>
      <UIText2 color={'gray60_100'}>{`${timeTo}.`}</UIText2>
    </div>
  );
}
